import {PlayerColor} from "@game/coregame/settings";

export const ColorItem = ({colorData}: {colorData?: PlayerColor}) => (
    <div className={"shop-item-color"} style={colorData ? `background:${colorData[0]}` : ``}></div>
);
